







import Vue from 'vue'

import supplierSearchPage from '../supplier-search-page.vue'

import { ProductMainInfo } from '@/types/supplier-search'

export default Vue.extend({
name: 'originSSF',
  components: {
    supplierSearchPage
  },
  mounted() {
    window.supplierSearchEventBus.$on('SHOW_ORIGIN_SUPPLIER_SEARCH_WINDOW', (data: ProductMainInfo) => {
      this.ignite = true;
      this.dataFromExternal = data;
    });
  },
  data() {
    return {
      ignite: false,
      dataFromExternal: {} as ProductMainInfo
    }
  },
})
